import React, { useState } from "react";
import SearchBar from "../../components/universal/SearchBar";
import AddTWGFields from "../../components/TWG/AddTWGFields";
import Navbar from "../../components/universal/Navbar";
import { Link, useLocation } from "react-router-dom";
function AddTwg() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex justify-end">
              <Link to={"/twg/all"}>
                <button className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                  Today with God List
                </button>
              </Link>
            </div>
            <AddTWGFields setLoading={setLoading} _id={location?.state?._id} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddTwg;
